import { Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { RootLayout } from "@/routes/__root";
import { IndexPage } from "@/routes/index";
import { SessionsPage } from "@/routes/sessions";
import { SessionDetailPage } from "@/routes/sessions.$id";
import { SearchPage } from "@/routes/search";
import { SettingsPage } from "@/routes/settings";
import { SharePage } from "@/routes/share.$token";
import { AuthCallbackPage } from "@/routes/auth.callback";

export default function App() {
  return (
    <>
      <Routes>
        <Route element={<RootLayout />}>
          <Route index element={<IndexPage />} />
          <Route path="sessions" element={<SessionsPage />} />
          <Route path="sessions/:id" element={<SessionDetailPage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="share/:token" element={<SharePage />} />
        <Route path="auth/callback" element={<AuthCallbackPage />} />
      </Routes>
      <Toaster />
    </>
  );
}
